import { Box } from "@mui/material";
import { ReactComponent as BackArrowIcon } from "../../asserts/logo/BackArrow.svg";

/** Figma back control — 20×16 arrow at top 8px / left 6px inside 32×32 hit target */
export default function IntakeHeaderBackButton({ onClick, "aria-label": ariaLabel = "Back" }) {
  if (!onClick) return null;

  return (
    <Box
      component="button"
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      sx={{
        position: "relative",
        width: 32,
        height: 32,
        flexShrink: 0,
        p: 0,
        m: 0,
        border: "none",
        bgcolor: "transparent",
        cursor: "pointer",
        borderRadius: "4px",
        // Hover and focus both follow the sidebar collapse control: grey fill on
        // hover, and the browser's default outline on focus.
        "&:hover": { bgcolor: "#F5F5F5" },
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{
          position: "absolute",
          top: "8px",
          left: "6px",
          width: 20,
          height: 16,
          opacity: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          "& svg": {
            width: 20,
            height: 16,
            display: "block",
          },
          "& path": {
            stroke: "#000000",
            strokeWidth: 2,
          },
        }}
      >
        <BackArrowIcon />
      </Box>
    </Box>
  );
}
